
export const getCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition((pos, err) => {
      if (pos) {
        return resolve(pos.coords)
      } else {
        return reject(err)
      }
    });
  })
}
export const getBase64Url = (file) => {
  var reader = new FileReader();
  reader.readAsDataURL(file);
  var base64 = new Promise(function (resolve, reject) {
    reader.onload = (event) => {
      if (event.target)
        resolve(event.target.result);
      else
        reject(new Error('fail'))
    };
  });
  return base64;
}

export const setDate = (date, day) => {
  date.setDate(day)
}

export const getCurrentMonth = (date) => {
  return date.getMonth() + 1
}

export const getFormattedDate = (date, formattedString) => {
  return date.getDate() + formattedString + getCurrentMonth(date) + formattedString + date.getFullYear()
}

export const getDateWithStaticDay = (date, formattedString, day) => {
  setDate(date, day)
  if (new Date().getDate() > 20) {
    return date.getDate() + formattedString + (getCurrentMonth(date) + 1) + formattedString + date.getFullYear()
  }
  return getFormattedDate(date, formattedString)
}

export const b64toBlob = (dataURI, type) => {
  let byteString = atob(dataURI.split(',')[1]);
  const _ab = new ArrayBuffer(byteString.length);
  var _ia = new Uint8Array(_ab);
  for (var i = 0; i < byteString.length; i++) {
    _ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([_ab], { type: type });
}

export const toaster = (_this, msg, position, duration) => {
	_this.$toasted.show(msg, {
		theme: "outline",
		duration: duration,
		position: position,
    closeOnSwipe: false,
    fitToScreen	: true,
		action: {
			text: "Close",
			onClick: (e, toastObject) => {
				toastObject.goAway(0);
			}
		}
	})
}
